/**
 * **デュエルの開始を疑似イベント `start` にする**（Issue #645）。**`duelEditor/` の外**。
 *
 * ygopro の MSG_START（先攻・LP・デッキの枚数）は core ではなくサーバー（gframe）が送るもので、ygopro-core は出さない。
 * 再現エンジンのイベント列は初手のドローから始まるので、ステータスの変化（`statChanges.js`。Issue #584）と同じく
 * **イベントの列の先頭に 1 行差し込む**:
 *
 * - **キー**: `op_seq` 無し・`msg_offset` = `START_EVENT_OFFSET`（200000）→ `start:200000`。最初の問い合わせより前なので
 *   時刻は replay の開始位置（`start_video_ms`）。既存の `start:{n}`・stat_change（100000 台）とぶつからず、
 *   サーバーの検証（`ocg/fx_docs.py` の `_EVENT_KEY` = 数字 6 桁まで）も通る
 * - **index**: -1（初手のドロー＝index 0 より前。盤面は空のまま）
 * - サービス側で出さないのは、イベントの index / msg_offset がずれると保存済みの位置合わせ（`start:{n}`）が
 *   別のイベントに付くため
 *
 * payload（`data`）: `{ player: 先攻, first_player: 先攻, lp: [開始 LP, 開始 LP] }`
 */

export const START_EVENT_TYPE = 'start';
/** 疑似イベントの `msg_offset`（既存のキーとぶつからない・サーバーの検証の 6 桁に入る） */
export const START_EVENT_OFFSET = 200000;

/**
 * @param events イベント列（`index` の昇順）
 * @returns 先頭に `start` を足した列（イベントが無い・既に先頭にあれば同じ参照）
 */
export function withStartEvent({ events = [], firstPlayer = 0, startLp = 8000 } = {}) {
  if (!events.length || events[0]?.type === START_EVENT_TYPE) return events;
  const player = firstPlayer === 1 ? 1 : 0;
  const lp = Number.isFinite(startLp) ? startLp : 8000;
  const ev = {
    id: 'start',
    index: -1,
    kind: 'event',
    type: START_EVENT_TYPE,
    turn: 0,
    turn_player: player,
    phase: null,
    chain_stack: [],
    solving: null,
    op_seq: null,
    msg_offset: START_EVENT_OFFSET,
    data: { player, first_player: player, lp: [lp, lp] },
  };
  return [ev, ...events];
}
